import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import listItems from 'flarum/common/helpers/listItems';
import PollState from '../../states/PollState';
import PollDraftBadges from './PollDraftBadges';
import PollImage from './PollImage';
import PollOptions from './PollOptions';
import PollSubmitButton from './PollSubmitButton';
export default class AbstractPoll extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = this.createState();
  }
  createState() {
    return new PollState(this.attrs.poll);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    window.addEventListener('beforeunload', this.preventClose);
  }
  onremove(vnode) {
    super.onremove(vnode);
    window.removeEventListener('beforeunload', this.preventClose);
  }
  preventClose = e => {
    if (this.state.hasSelectedOptions()) {
      e.preventDefault();
      e.returnValue = '';
    }
  };
  view() {
    const poll = this.attrs.poll;
    return m("div", {
      className: classList(this.className(), poll.imageUrl() && 'Poll--image'),
      "data-id": poll.id()
    }, this.viewItems().toArray());
  }
  viewItems() {
    const items = new ItemList();
    items.add('header', m("div", {
      className: "Poll-header"
    }, this.headerItems().toArray()), 100);
    items.add('content', m("div", {
      className: "Poll-content"
    }, this.contentItems().toArray()), 50);
    items.add('footer', m("div", {
      className: "Poll-footer"
    }, this.footerItems().toArray()), 0);
    return items;
  }
  headerItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    items.add('title', m("h3", {
      className: "Poll-title"
    }, poll.question(), m(PollDraftBadges, {
      poll: poll
    })), 100);
    if (poll.subtitle()) {
      items.add('subtitle', m("p", {
        className: "Poll-subtitle helpText"
      }, poll.subtitle()), 50);
    }
    const controls = this.controlsView();
    if (controls) items.add('controls', controls, 0);
    return items;
  }
  contentItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (poll.imageUrl()) {
      items.add('image', m(PollImage, {
        poll: poll
      }), 100);
    }
    items.add('options', m("fieldset", {
      className: "Poll-optionsFieldset"
    }, m("legend", {
      className: "sr-only"
    }, poll.question()), m(PollOptions, {
      name: `poll${poll.id()}`,
      options: poll.options(),
      state: this.state
    })), 50);
    return items;
  }
  footerItems() {
    const items = new ItemList();
    const infoItems = this.infoItems();
    if (!infoItems.isEmpty()) {
      items.add('info', m("ul", {
        className: "PollInfoText helpText"
      }, listItems(infoItems.toArray())), 100);
    }
    if (this.state.showButton()) {
      items.add('submit', m(PollSubmitButton, {
        state: this.state
      }), 0);
    }
    return items;
  }
  controlsView() {
    const controls = this.controlItems().toArray();
    if (!controls.length) return null;
    return m(Dropdown, {
      icon: "fas fa-ellipsis-v",
      className: "Poll-controls",
      menuClassName: "Dropdown-menu--right",
      buttonClassName: "Button Button--icon Button--flat",
      accessibleToggleLabel: app.translator.trans('fof-polls.forum.poll_controls.toggle_dropdown_accessible_label')
    }, controls);
  }
  infoItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    const state = this.state;
    if (app.session.user && !poll.canVote() && !poll.hasEnded()) {
      items.add('no-permission', this.info('fas fa-times-circle', app.translator.trans('fof-polls.forum.no_permission')), 100);
    }
    if (poll.endDate()) {
      items.add('end-date', this.info('fas fa-clock', poll.hasEnded() ? app.translator.trans('fof-polls.forum.poll_ended') : app.translator.trans('fof-polls.forum.days_remaining', {
        time: dayjs(poll.endDate()).fromNow()
      })), 90);
    }
    if (poll.canVote() && !poll.hasEnded() && !state.hasVoted()) {
      items.add('max-votes', this.info('fas fa-poll', app.translator.trans('fof-polls.forum.max_votes_allowed', {
        max: state.getMaxVotes()
      })), 80);
      if (!poll.canChangeVote()) {
        items.add('cannot-change-vote', this.info('fas fa-exclamation-circle', app.translator.trans('fof-polls.forum.poll.cannot_change_vote')), 70);
      }
    }
    if (state.canSeeVoteCount && (poll.hasEnded() || state.hasVoted())) {
      items.add('total-vote-count', this.info('fas fa-poll', app.translator.trans('fof-polls.forum.poll.total_votes', {
        count: poll.voteCount()
      })), 60);
    }
    return items;
  }
  info(icon, text) {
    return m("span", null, m(Icon, {
      name: icon,
      className: "fa-fw"
    }), text);
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/AbstractPoll', AbstractPoll);